import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/AskAnExpert/Banner'
import FormSection from '../Component/AskAnExpert/Form'
import Footer from '../Component/NavBarFooter/Footer'
// import OurTeam from '../Component/OurMission/OurTeam'

function AskAnExpert() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <FormSection/>
        {/* <OurTeam/> */}
        <Footer/>
    </div>
  )
}

export default AskAnExpert